export const formatNumberWithCommas = (value: number): string => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const toTitleCase = (firstName: string, lastName: string): string => {
  const name = `${firstName} ${lastName}`;
  return name
    .split(' ')
    .map((word) =>
      word.length === 1 ? word : word[0] + word.slice(1).toLowerCase()
    )
    .join(' ');
};
